@if (isLoading()) {
} @else {

	<peps-booster-opening [hasNextBooster]="hasBoostersToOpen()" (openNext)="openNextBooster()"/>

	@if (selectedCard()) {
		<div
			@fadeInOut
			class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto py-10 bg-peps-dark-900/85 backdrop-blur-sm"
			(click)="onCardDetailBackdropClick($event)"
			(keydown.enter)="onCardDetailBackdropClick($event)"
		>
			<button
				class="fixed top-6 right-6 z-10 text-peps-dark-200/50 hover:text-white transition-colors duration-200 cursor-pointer"
				(click)="closeCardDetail()"
				(keydown.enter)="closeCardDetail()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
				     stroke="currentColor" class="size-8 lg:size-9">
					<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
				</svg>
			</button>
			<div @scaleInOut class="relative flex flex-col items-center gap-6">
				<!-- x3 la taille carte grille : scale plafonnée pour tenir dans le viewport -->
				<div style="transform: scale(min(3, calc(85vh / 410px), calc(90vw / 280px))); transform-origin: center; will-change: transform;">
					<app-card
						[rarity]="selectedCard()!.card.rarity"
						[name]="selectedCard()!.card.name"
						[score]="selectedCard()!.score"
						[rating]="selectedCard()!.card.rating"
						[image]="selectedCard()!.card.fileName"
						[interactive]="false"
						[staticDisplay]="true"
						[showLoader]="true"
						[extensionId]="selectedCard()!.card.extension.id"
						[author]="selectedCard()!.card.author"
					/>
				</div>
			</div>
		</div>
	}

	<!-- ══ MODAL DÉTAIL (bouton œil) — historique des prix + détruire/vendre ══ -->
	@if (!isDestroyConfirming() && viewingCard(); as entry) {
		<div
			@fadeInOut
			class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto py-10"
			(click)="onCardDetailPanelBackdropClick($event)"
			(keydown.enter)="onCardDetailPanelBackdropClick($event)"
		>
			<!-- Firefox : le flou doit être un calque frère (pas un ancêtre) du contenu,
			     sinon les <input> à l'intérieur ne prennent pas le focus au clic. -->
			<div class="fixed inset-0 bg-peps-dark-900/85 backdrop-blur-sm pointer-events-none" aria-hidden="true"></div>
			<button
				class="fixed top-6 right-6 z-10 text-peps-dark-200/50 hover:text-white transition-colors duration-200 cursor-pointer"
				(click)="closeCardDetailPanel()"
				(keydown.enter)="closeCardDetailPanel()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
				     stroke="currentColor" class="size-8 lg:size-9">
					<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
				</svg>
			</button>

			<div @scaleInOut class="relative bg-peps-dark-800 border border-peps-dark-500 p-6 md:p-8 w-full max-w-4xl mx-4 flex flex-col md:flex-row gap-8">

				<!-- Carte en grand -->
				<div class="flex justify-center md:block shrink-0">
					<div class="relative w-[210px] h-[307.5px] lg:w-[364px] lg:h-[533px]">
						<div class="origin-top-left scale-[0.75] lg:scale-[1.3] pointer-events-none">
							<app-card
								[rarity]="entry.card.rarity"
								[name]="entry.card.name"
								[score]="entry.score"
								[rating]="entry.card.rating"
								[image]="entry.card.fileName"
								[extensionId]="entry.card.extension.id"
								[interactive]="false"
								[staticDisplay]="true"
								[showLoader]="true"
								[author]="entry.card.author"
							/>
						</div>
					</div>
				</div>

				<!-- Détail + historique + actions -->
				<div class="flex flex-col gap-5 flex-1 min-w-0 mt-6 md:mt-0">

					<div>
						<span class="text-[11px] uppercase tracking-[0.3em] font-dinpro-medium text-peps-gold/40">{{ rarityLabelKey(entry.card.rarity) | translate }}</span>
						<h2 class="text-2xl md:text-4xl font-dinpro-bold uppercase text-white mt-0.5">{{ entry.card.name }}</h2>
						@if (entry.quantity > 1) {
							<span class="text-sm lg:text-base uppercase text-peps-dark-200/40 font-notosans">×{{ entry.quantity }}</span>
						}
					</div>

					<!-- Historique des prix -->
					<div class="flex flex-col gap-2">
						<span class="text-[11px] uppercase tracking-[0.2em] font-dinpro-medium text-peps-dark-200/30">{{ 'page.marketplace.detail.price-history' | translate }}</span>
						@if (isDetailSalesLoading()) {
							<div class="flex items-center justify-center py-10">
								<span class="inline-block w-6 h-6 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
							</div>
						} @else if (detailSalesNotFound()) {
							<div class="border border-dashed border-peps-dark-500 py-6 flex items-center justify-center">
								<span class="text-xs lg:text-sm uppercase tracking-wider text-peps-dark-200/30">{{ 'page.marketplace.detail.card-not-found' | translate }}</span>
							</div>
						} @else {
							<peps-price-history-chart [sales]="detailSales()" />
						}
					</div>

					<!-- Actions -->
					<div class="mt-auto flex flex-col gap-3 pt-3 border-t border-peps-dark-500">

						<!-- Mettre en vente (masqué quand le marketplace est en maintenance) -->
						@if (!featureFlagService.isStrictlyEnabled('MARKETPLACE')) {
							<button
								disabled
								class="text-sm lg:text-base uppercase tracking-wider px-4 py-2.5 border border-peps-dark-500 text-peps-dark-200/30 cursor-not-allowed"
							>
								{{ 'page.marketplace.maintenance.heading' | translate }}
							</button>
						} @else {
							<div class="flex flex-col gap-2">
								<div class="flex items-center gap-3">
									<input
										type="number"
										[min]="destroyValue()"
										[value]="sellPrice()"
										(input)="sellPrice.set(+$any($event.target).value)"
										class="w-28 px-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium text-peps-dark-200 outline-none focus:border-peps-gold/40 transition-colors tabular-nums"
									/>
									<span class="text-sm lg:text-base uppercase tracking-widest text-peps-gold/50">PepsCoins</span>
								</div>
								<div class="flex gap-2">
									<button
										class="flex-1 text-xs lg:text-sm uppercase tracking-wider text-peps-dark-200/40 hover:text-peps-dark-200/70 transition-colors px-3 py-2 border border-peps-dark-500 cursor-pointer"
										[disabled]="isListingFromDetail()"
										(click)="cancelSellCard()"
										(keydown.enter)="cancelSellCard()"
									>
										{{ 'page.marketplace.sell-modal.cancel' | translate }}
									</button>
									<button
										class="flex-1 text-xs lg:text-sm uppercase tracking-wider px-3 py-2 border transition-colors flex items-center justify-center"
										[ngClass]="sellPrice() > 0 && !isListingFromDetail() && sellPrice() >= destroyValue() ? 'border-peps-gold/40 text-peps-gold hover:bg-peps-gold/10 cursor-pointer' : 'border-peps-dark-500 text-peps-dark-200/30 cursor-not-allowed'"
										[disabled]="sellPrice() <= 0 || isListingFromDetail() || sellPrice() < destroyValue()"
										(click)="confirmSellFromDetail()"
										(keydown.enter)="confirmSellFromDetail()"
									>
										@if (isListingFromDetail()) {
											<span class="inline-block w-4 h-4 border-2 border-peps-gold/50 border-t-transparent rounded-full animate-spin"></span>
										} @else {
											{{ 'page.marketplace.sell-modal.confirm' | translate }}
										}
									</button>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	}

	<!-- Rendu après la modal détail pour toujours s'afficher au-dessus quand les deux sont actives -->
	@if (isDestroyConfirming()) {
		<div
			@fadeInOut
			class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto py-10 bg-peps-dark-900/85 backdrop-blur-sm"
			(click)="onDestroyModalBackdropClick($event)"
			(keydown.enter)="onDestroyModalBackdropClick($event)"
		>
			<button
				class="fixed top-6 right-6 z-10 text-peps-dark-200/50 hover:text-white transition-colors duration-200 cursor-pointer"
				(click)="cancelDestroyCard()"
				(keydown.enter)="cancelDestroyCard()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
				     stroke="currentColor" class="size-8 lg:size-9">
					<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
				</svg>
			</button>
			<div class="flex flex-col gap-2 border-2 border-red-500 p-3 md:p-4 lg:p-6 bg-peps-dark-800">
				<span class="text-sm font-notosans lg:text-base text-red-400/80">{{ 'page.profile.inventory.detail.destroy-confirm-message' | translate:{ coins: destroyValue() } }}</span>
				<div class="flex gap-2">
					<button
						class="flex-1 text-xs lg:text-sm uppercase tracking-wider text-peps-dark-200/40 hover:text-peps-dark-200/70 transition-colors px-3 py-2 border border-peps-dark-500 cursor-pointer"
						[disabled]="isDestroying()"
						(click)="cancelDestroyCard()"
						(keydown.enter)="cancelDestroyCard()"
					>
						{{ 'page.marketplace.sell-modal.cancel' | translate }}
					</button>
					<button
						class="flex-1 text-xs lg:text-sm uppercase tracking-wider px-3 py-2 border border-red-400/50 text-red-400 hover:bg-red-400/10 transition-colors cursor-pointer flex items-center justify-center"
						[disabled]="isDestroying()"
						(click)="confirmDestroyCard()"
						(keydown.enter)="confirmDestroyCard()"
					>
						@if (isDestroying()) {
							<span class="inline-block w-4 h-4 border-2 border-red-400/50 border-t-transparent rounded-full animate-spin"></span>
						} @else {
							{{ 'page.profile.inventory.detail.destroy-confirm' | translate }}
						}
					</button>
				</div>
			</div>
		</div>
	}

	<div class="flex flex-col min-h-screen">

		<!-- ══ BANNIÈRE ══════════════════════════════════════════════════ -->
		<div class="relative h-[180px] md:h-[260px] lg:h-[324px] overflow-hidden shrink-0 bg-peps-dark-900">

			<!-- Image de bannière (base) -->
			<img src="/assets/images/banner.jpg" alt=""
			     class="absolute inset-0 w-full h-full object-cover">

			<!-- Trait or en bas -->
			<div class="absolute bottom-0 left-0 right-0 h-px pointer-events-none"
			     style="background: linear-gradient(90deg, transparent 0%, rgba(238,201,50,0.5) 30%, rgba(238,201,50,0.5) 70%, transparent 100%);">
			</div>

		</div>

		<!-- ══ EN-TÊTE PROFIL ════════════════════════════════════════════ -->
		<div class="px-6 md:px-10 lg:px-20 pb-0">

			<div class="flex flex-col sm:flex-row sm:items-end gap-4 sm:gap-6 md:gap-8">

				<!-- Avatar — chevauche la bannière -->
				<div class="mt-[-40px] md:mt-[-52px] lg:mt-[-64px] shrink-0 relative z-10">
					@if (user()?.picture) {
						<div class="w-fit rounded-full p-[3px]"
						     style="background: linear-gradient(135deg, #EEC932 0%, #fdf7bd 40%, rgba(238,201,50,0.35) 70%, #EEC932 100%); box-shadow: 0 0 28px rgba(238,201,50,0.28), 0 0 8px rgba(238,201,50,0.15);">
							<div class="w-20 h-20 md:w-28 md:h-28 lg:w-36 lg:h-36 rounded-full overflow-hidden">
								<img [src]="user()!.picture" [alt]="user()!.username"
								     class="w-full h-full object-cover">
							</div>
						</div>
					} @else {
						<div class="w-fit rounded-full p-[3px]"
						     style="background: linear-gradient(135deg, #EEC932, rgba(238,201,50,0.3));">
							<div
								class="w-20 h-20 md:w-28 md:h-28 lg:w-36 lg:h-36 rounded-full bg-peps-dark-600 flex items-center justify-center">
								<span class="text-4xl lg:text-5xl font-dinpro text-peps-gold/60 uppercase">
									{{ user()?.username?.charAt(0) ?? '?' }}
								</span>
							</div>
						</div>
					}
				</div>

				<div class="flex flex-col gap-1 pb-3 md:pb-5 flex-1 min-w-0">
					<span class="text-[10px] uppercase font-dinpro-medium text-peps-gold/60 tracking-[0.35em]">
						Team Peps
					</span>
					<h1 class="text-3xl md:text-5xl lg:text-7xl uppercase font-dinpro leading-none truncate"
					    style="background: linear-gradient(90deg, #EEC932 0%, #fdf7bd 55%, #ffffff 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">
						{{ user()?.username ?? '—' }}
					</h1>
				</div>

			</div>

		</div>

		<!-- ══ TABS ══════════════════════════════════════════════════════ -->
		<div class="mt-2 border-b border-peps-dark-500 overflow-x-auto custom-scrollbar">
			<div class="flex px-6 md:px-10 lg:px-20 min-w-max">

				@for (tab of ([
					{id: 'inventory', label: 'page.profile.tab.inventory'    | translate},
					{id: 'favorites', label: 'page.profile.tab.favorites'    | translate},
					{id: 'predictions', label: 'page.profile.tab.predictions'  | translate},
					{id: 'achievements', label: 'page.profile.tab.achievements' | translate},
					{id: 'account', label: 'page.profile.tab.account'      | translate}
				]); track tab.id) {
					<button
						class="px-5 py-4 text-xs lg:text-sm uppercase font-dinpro-medium tracking-wider whitespace-nowrap transition-all duration-200 cursor-pointer border-b-2"
						[ngClass]="selectedTab() === tab.id
							? 'border-peps-gold text-peps-gold'
							: 'border-transparent text-peps-dark-200/40 hover:text-peps-dark-200/70'"
						(click)="selectTab(tab.id)"
						(keydown.enter)="selectTab(tab.id)"
					>{{ tab.label }}
					</button>
				}

			</div>
		</div>

		<!-- ══ CONTENU DES TABS ══════════════════════════════════════════ -->
		<div class="px-6 md:px-10 lg:px-20 py-8 flex-1">

			<!-- ─── INVENTAIRE ─── -->
			@if (selectedTab() === 'inventory') {
				<div class="flex flex-col gap-10 animate-fade-in">

					<!-- Section : Boosters -->
					<div class="flex flex-col gap-5">
						<div class="flex items-center gap-4">
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.profile.inventory.section-boosters' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
							<span class="flex items-center gap-1.5 text-sm uppercase font-dinpro-medium text-peps-dark-200/40 tracking-wider shrink-0">
								<img src="assets/images/booster/booster_extension_0.png" alt="" class="w-4 h-4 shrink-0">
								{{ user()?.boostersOpened ?? 0 }} {{ 'page.profile.boosters-opened-label' | translate }}
							</span>
						</div>

						@if (inventory()?.boosters?.length) {
							<div class="flex flex-row flex-wrap gap-8 [&>*]:max-w-[144px]">
								@for (entry of inventory()?.boosters; track entry.booster.id) {
									<div class="flex flex-col gap-4 items-center relative">
										<svg
											[pepsTooltipHtml]="boosterTooltipHtml(entry.booster.raritiesAllowed)"
											xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
											stroke-width="1.5" stroke="currentColor"
											class="absolute top-0 right-0 z-10 size-5 lg:size-6 text-peps-dark-200/30 hover:text-peps-dark-200/70 transition-colors duration-150 cursor-default font-notosans">
											<path stroke-linecap="round" stroke-linejoin="round"
											      d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/>
										</svg>
										@if (boosterImage(entry.booster); as img) {
										<div class="w-full flex justify-center">
											<img [src]="img" [alt]="entry.booster.name"
											     class="w-36 h-36 shrink-0 object-contain"/>
										</div>
									} @else {
										<peps-booster-display/>
									}
										<span
											class="uppercase font-dinpro-medium px-2 py-0.5 border border-peps-gold/30 text-peps-gold/60">x{{ entry.quantity }}</span>
										<button
											class="w-fit px-8 py-3.5 uppercase font-dinpro-medium text-base lg:text-lg text-peps-dark-900 bg-peps-gold hover:bg-peps-yellow transition-colors duration-200 cursor-pointer disabled:opacity-40 disabled:pointer-events-none"
											[disabled]="isOpeningBooster()"
											(click)="openBooster(entry.booster.id)"
											(keydown.enter)="openBooster(entry.booster.id)"
										>
											{{ 'page.profile.open' | translate }}
										</button>
									</div>
								}
							</div>
						} @else {
							<div
								class="border border-peps-dark-500 border-dashed py-12 flex flex-col items-center gap-3">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
								     stroke="currentColor"
								     class="size-10 lg:size-11 text-peps-dark-200/20">
									<path stroke-linecap="round" stroke-linejoin="round"
									      d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016 2.993 2.993 0 0 0 2.25-1.016 3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"/>
								</svg>
								<span
									class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.profile.inventory.no-boosters' | translate }}</span>
							</div>
						}
					</div>

					<!-- Section : Cartes -->
					<div class="flex flex-col gap-5">
						<div class="flex items-center gap-4">
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.profile.inventory.section-cards' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>

						@if (inventory()?.cards?.length) {
							<div class="flex flex-col md:flex-row gap-6">

								<!-- ── Sidebar filtres ── -->
								<div class="flex flex-col gap-4 md:w-60 shrink-0">

									<!-- Recherche -->
									<div class="relative flex items-center">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
										     stroke-width="1.5" stroke="currentColor"
										     class="absolute left-3 size-4 lg:size-5 text-peps-dark-200/30 pointer-events-none">
											<path stroke-linecap="round" stroke-linejoin="round"
											      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
										</svg>
										<input
											type="text"
											[placeholder]="'page.profile.inventory.search-placeholder' | translate"
											[value]="cardNameFilter()"
											(input)="onNameFilterInput($event)"
											class="w-full pl-9 pr-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-sm lg:text-base font-dinpro-medium uppercase tracking-wide text-peps-dark-200 placeholder:text-peps-dark-200/30 outline-none focus:border-peps-gold/40 transition-colors duration-150"
										/>
									</div>

									<button
										class="flex items-center gap-2.5 px-3 py-2.5 text-xs lg:text-sm uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
										[style.border-color]="isShowNotOwnedCard() === true ? '#EEC932' : 'rgba(255,255,255,0.07)'"
										[style.color]="isShowNotOwnedCard() === true ? '#EEC932' : 'rgba(255,255,255,0.3)'"
										[style.background]="isShowNotOwnedCard() === true ? 'rgba(238,201,50,0.12)' : '#131415'"
										(click)="toggleShowNotOwned()"
										(keydown.enter)="toggleShowNotOwned()"
									>
										<span
											class="flex-1">{{ 'page.profile.inventory.show-not-owned' | translate }}</span>
									</button>

									<!-- Raretés (sélection simple — filtre serveur sur une seule rareté à la fois) -->
									<div class="flex flex-col gap-1">
										<span
											class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.profile.inventory.filter-rarity-label' | translate }}</span>
										<button
											class="flex items-center gap-2.5 px-3 py-2.5 text-xs lg:text-sm uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
											[style.border-color]="selectedRarity() === null ? '#EEC932' : 'rgba(255,255,255,0.07)'"
											[style.color]="selectedRarity() === null ? '#EEC932' : 'rgba(255,255,255,0.3)'"
											[style.background]="selectedRarity() === null ? 'rgba(238,201,50,0.12)' : '#131415'"
											(click)="setRarityFilter(null)"
											(keydown.enter)="setRarityFilter(null)"
										>
											<span class="size-2 lg:size-2.5 rounded-full shrink-0"
											      style="background: #EEC932"></span>
											<span
												class="flex-1">{{ 'page.profile.inventory.filter-all' | translate }}</span>
											<span class="tabular-nums opacity-60">{{ cardStats()?.totalOwned ?? 0 }}
												/ {{ cardStats()?.total ?? 0 }}</span>
										</button>
										@for (r of rarityOptions; track r.key) {
											<button
												class="flex items-center gap-2.5 px-3 py-2.5 text-xs lg:text-sm uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-left"
												[style.border-color]="selectedRarity() === r.key ? r.color : 'rgba(255,255,255,0.07)'"
												[style.color]="selectedRarity() === r.key ? r.color : 'rgba(255,255,255,0.3)'"
												[style.background]="selectedRarity() === r.key ? r.bg : '#131415'"
												(click)="setRarityFilter(r.key)"
												(keydown.enter)="setRarityFilter(r.key)"
											>
												<span class="size-2 lg:size-2.5 rounded-full shrink-0"
												      [style.background]="r.color"></span>
												<span class="flex-1">{{ r.labelKey | translate }}</span>
												<span
													class="tabular-nums opacity-60">{{ (cardStats()?.byRarity?.[r.key]?.owned ?? 0) }}
													/ {{ (cardStats()?.byRarity?.[r.key]?.total ?? 0) }}</span>
											</button>
										}

										<div class="flex flex-col gap-1">
											<span class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{'page.marketplace.filter-extension-label' | translate }}</span>
											<select
												[value]="selectedExtension() ?? ''"
												(change)="setExtensionFilter($any($event.target).value)"
												class="w-full px-3 py-2 bg-peps-dark-600 border border-peps-dark-500 text-base lg:text-lg font-dinpro-medium uppercase tracking-wide text-peps-dark-200 outline-none focus:border-peps-gold/40 transition-colors duration-150 cursor-pointer"
											>
												<option value="">{{ 'page.marketplace.filter-all' | translate }}</option>
												@for (extension of extensions(); track extension.id) {
													<option [value]="extension.id">{{ extension.name }}</option>
												}
											</select>
										</div>
									</div>

									<!-- Tri -->
									<div class="flex flex-col gap-1">
										<span
											class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em] mb-1">{{ 'page.profile.inventory.sort-label' | translate }}</span>
										<div class="flex gap-1">
											@for (s of [{ key: 'rarity', labelKey: 'page.profile.inventory.sort-rarity' }, { key: 'name', labelKey: 'page.profile.inventory.sort-name' }, { key: 'score', labelKey: 'page.profile.inventory.sort-score' }]; track s.key) {
												<button
													class="flex-1 px-3 py-2.5 text-xs lg:text-sm uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-center"
													[style.border-color]="inventorySort() === s.key ? '#EEC932' : 'rgba(255,255,255,0.07)'"
													[style.color]="inventorySort() === s.key ? '#EEC932' : 'rgba(255,255,255,0.3)'"
													[style.background]="inventorySort() === s.key ? 'rgba(238,201,50,0.12)' : '#131415'"
													(click)="setInventorySort(s.key === 'name' ? 'name' : (s.key === 'score' ? 'score' : 'rarity'))"
													(keydown.enter)="setInventorySort(s.key === 'name' ? 'name' : (s.key === 'score' ? 'score' : 'rarity'))"
												>
													{{ s.labelKey | translate }}
												</button>
											}
										</div>
										<div class="flex gap-1 mt-1">
											@for (d of [{ key: 'desc', labelKey: 'page.profile.inventory.sort-direction-desc' }, { key: 'asc', labelKey: 'page.profile.inventory.sort-direction-asc' }]; track d.key) {
												<button
													class="flex-1 px-3 py-2 text-xs lg:text-sm uppercase font-dinpro-medium tracking-wider border transition-all duration-150 cursor-pointer text-center"
													[style.border-color]="inventorySortDirection() === d.key ? '#EEC932' : 'rgba(255,255,255,0.07)'"
													[style.color]="inventorySortDirection() === d.key ? '#EEC932' : 'rgba(255,255,255,0.3)'"
													[style.background]="inventorySortDirection() === d.key ? 'rgba(238,201,50,0.12)' : '#131415'"
													(click)="setInventorySortDirection(d.key === 'asc' ? 'asc' : 'desc')"
													(keydown.enter)="setInventorySortDirection(d.key === 'asc' ? 'asc' : 'desc')"
												>
													{{ d.labelKey | translate }}
												</button>
											}
										</div>
									</div>
								</div>

								<!-- ── Grille ── -->
								<div class="flex-1 min-w-0">
									@if (isInventoryCardsLoading() && !pagedCards().length) {
										<div class="flex items-center justify-center py-24">
											<span class="inline-block w-8 h-8 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
										</div>
									} @else if (pagedCards().length) {
										<div class="flex flex-row flex-wrap gap-10 justify-center md:justify-start">
											@for (entry of pagedCards(); track entry.card.id) {
												@if(entry.score === 0) {
													@if(isShowNotOwnedCard()) {
														<div
															class="border-2 border-peps-gold/60 border-dashed rounded-[20px] w-[154px] h-[225.5px] lg:w-[238px] lg:h-[348.5px] flex items-center justify-center bg-peps-dark-700"
														>
															<span class="text-peps-gold/60 text-9xl font-bold">?</span>
														</div>
													}
												} @else {
													<div class="flex flex-col items-center gap-3">
														<div
															class="relative w-[154px] h-[225.5px] lg:w-[238px] lg:h-[348.5px] cursor-pointer"
															(click)="openCardDetail(entry)"
															(keydown.enter)="openCardDetail(entry)"
														>
															<div
																class="origin-top-left scale-[0.55] lg:scale-[0.85]">
																<app-card
																	[rarity]="entry.card.rarity"
																	[name]="entry.card.name"
																	[score]="entry.score"
																	[rating]="entry.card.rating"
																	[image]="entry.card.fileName"
																	[extensionId]="entry.card.extension.id"
																	[paused]="selectedCard() !== null || viewingCard() !== null || isBoosterOpening()"
																	[showLoader]="true"
																	[author]="entry.card.author"
																/>
															</div>
														</div>
														<div class="flex flex-row gap-2">
															@if (entry.card.rarity !== 'COLLECTOR') {
																<button
																	(click)="$event.stopPropagation(); requestDestroyCard(entry)"
																	(keydown.enter)="$event.stopPropagation(); requestDestroyCard(entry)"
																	class="cursor-pointer px-2 uppercase py-0.5 border border-peps-red/30 text-peps-red/60"
																>
																	{{ 'page.profile.inventory.detail.destroy-button' | translate }}
																</button>
															}
															<button
																(click)="$event.stopPropagation(); openCardDetailPanel(entry)"
																(keydown.enter)="$event.stopPropagation(); openCardDetailPanel(entry)"
																class="cursor-pointer px-2 uppercase py-0.5 border border-peps-gold text-peps-gold"
															>
																{{ 'page.profile.inventory.detail.sell-button' | translate }}
															</button>
															@if (entry.quantity > 1) {
																<span class="uppercase font-dinpro-medium px-2 py-0.5 border border-peps-gold/30 text-peps-gold/60 text-base lg:text-lg">x{{ entry.quantity }}</span>
															}
														</div>

													</div>
												}
											}
										</div>
										@if (inventoryHasMore()) {
											<div #inventoryLoadMoreAnchor class="flex justify-center items-center mt-10 h-10" aria-hidden="true">
												@if (isInventoryLoadingMore()) {
													<span class="inline-block w-5 h-5 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
												}
											</div>
										}
									} @else {
										<div
											class="border border-peps-dark-500 border-dashed py-12 flex flex-col items-center gap-3">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
											     stroke-width="1" stroke="currentColor"
											     class="size-10 lg:size-11 text-peps-dark-200/20">
												<path stroke-linecap="round" stroke-linejoin="round"
												      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/>
											</svg>
											<span
												class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.profile.inventory.no-filter-results' | translate }}</span>
										</div>
									}
								</div>

							</div>
						} @else {
							<div
								class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
								     stroke="currentColor"
								     class="size-10 lg:size-11 text-peps-dark-200/20">
									<path stroke-linecap="round" stroke-linejoin="round"
									      d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"/>
								</svg>
								<span
									class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.profile.inventory.no-cards' | translate }}</span>
							</div>
						}
					</div>

				</div>
			}

			<!-- ─── FAVORIS ─── -->
			@if (selectedTab() === 'favorites') {
				<div class="flex flex-col gap-6 animate-fade-in">

					<div class="flex items-center gap-4">
						<span
							class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.profile.favorites.section-title' | translate }}</span>
						<div class="flex-1 h-px bg-peps-dark-500"></div>
					</div>

					<p class="text-sm lg:text-base font-notosans text-peps-dark-200/50 max-w-xl">{{ 'page.profile.favorites.description' | translate }}</p>

					@if (inventory()?.cards?.length) {

						<!-- Slots -->
						<div class="flex flex-row flex-wrap gap-4">
							@for (slot of favoriteSlots(); track $index; let i = $index) {
								<div
									[id]="favoriteSlotListIds[i]"
									cdkDropList
									[cdkDropListConnectedTo]="favoriteDropListIds"
									[cdkDropListData]="[slot]"
									(cdkDropListDropped)="onFavoriteSlotDrop($event, i)"
									class="relative flex items-center justify-center border-2 border-dashed border-peps-dark-500 transition-colors duration-150 w-[101px] h-[148px] lg:w-[129px] lg:h-[189px]"
									[style.border-color]="slot ? 'rgba(238,201,50,0.35)' : ''"
								>
									@if (slot) {
										<div cdkDrag [cdkDragData]="slot" class="relative cursor-grab active:cursor-grabbing w-[101px] h-[148px] lg:w-[129px] lg:h-[189px]">
											<div class="origin-top-left scale-[0.36] lg:scale-[0.46]">
												<app-card
													[rarity]="slot.card.rarity"
													[name]="slot.card.name"
													[score]="slot.score"
													[rating]="slot.card.rating"
													[extensionId]="slot.card.extension.id"
													[image]="slot.card.fileName"
													[paused]="isBoosterOpening()"
													[showLoader]="true"
													[author]="slot.card.author"
												/>
											</div>
										</div>
										<button
											class="absolute -top-2 -right-2 z-10 size-5 lg:size-6 rounded-full bg-peps-dark-700 border border-peps-dark-500 text-peps-dark-200/60 hover:text-red-400 hover:border-red-400/50 flex items-center justify-center cursor-pointer transition-colors duration-150"
											(click)="removeFavoriteSlot(i)"
											(keydown.enter)="removeFavoriteSlot(i)"
										>
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
											     stroke-width="2" stroke="currentColor" class="size-3 lg:size-3.5">
												<path stroke-linecap="round" stroke-linejoin="round"
												      d="M6 18 18 6M6 6l12 12"/>
											</svg>
										</button>
									} @else {
										<span
											class="text-[11px] uppercase tracking-widest text-peps-dark-200/25">{{ 'page.profile.favorites.slot-empty' | translate }} {{ i + 1 }}</span>
									}
								</div>
							}
						</div>

						<!-- Enregistrer / réinitialiser -->
						<div class="flex items-center gap-4">
							<button
								class="w-fit px-6 py-2.5 uppercase font-dinpro-medium text-sm lg:text-base text-peps-dark-900 bg-peps-gold hover:bg-peps-yellow transition-colors duration-200 cursor-pointer disabled:opacity-40 disabled:pointer-events-none flex items-center gap-2"
								[disabled]="!canSaveFavorites() || isSavingFavorites()"
								(click)="saveFavorites()"
								(keydown.enter)="saveFavorites()"
							>
								@if (isSavingFavorites()) {
									<span
										class="inline-block w-3.5 h-3.5 border-2 border-peps-dark-900/60 border-t-transparent rounded-full animate-spin"></span>
								}
								{{ 'page.profile.favorites.save' | translate }}
							</button>
							@if (favoritesDirty()) {
								<button
									class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/40 hover:text-peps-dark-200/70 transition-colors duration-150 cursor-pointer disabled:opacity-40 disabled:pointer-events-none"
									[disabled]="isSavingFavorites()"
									(click)="resetFavorites()"
									(keydown.enter)="resetFavorites()"
								>
									{{ 'page.profile.favorites.reset' | translate }}
								</button>
							}
						</div>

						<!-- Pool des cartes possédées -->
						<div class="flex flex-col gap-3 mt-2">
							<span
								class="text-[11px] uppercase font-dinpro-medium text-peps-dark-200/30 tracking-[0.3em]">{{ 'page.profile.favorites.pool-label' | translate }}</span>
							@if (isFavoritesPoolLoading() && !favoritesPoolCards().length) {
								<div class="flex items-center justify-center py-10">
									<span class="inline-block w-6 h-6 border-2 border-peps-gold/40 border-t-transparent rounded-full animate-spin"></span>
								</div>
							} @else {
								<div
									[id]="favoritePoolListId"
									cdkDropList
									[cdkDropListConnectedTo]="favoriteDropListIds"
									[cdkDropListData]="favoritePool()"
									(cdkDropListDropped)="onFavoritePoolDrop($event)"
									class="flex flex-row flex-wrap gap-4 min-h-[100px]"
								>
									@for (owned of favoritePool(); track owned.userCardId) {
											<div
												cdkDrag
												[cdkDragData]="owned"
												class="relative cursor-grab active:cursor-grabbing w-[90px] h-[131px] lg:w-[115px] lg:h-[168px]"
												(click)="addFavoriteToFirstEmptySlot(owned)"
												(keydown.enter)="addFavoriteToFirstEmptySlot(owned)"
											>
												@if (owned.remaining > 1) {
													<span class="absolute top-1 right-1 z-10 px-1.5 rounded bg-peps-dark-700/90 border border-peps-gold/40 text-peps-gold text-xs font-dinpro-medium">x{{ owned.remaining }}</span>
												}
												<div class="origin-top-left scale-[0.32] lg:scale-[0.41]">
													<app-card
														[extensionId]="owned.card.extension.id"
														[rarity]="owned.card.rarity"
														[name]="owned.card.name"
														[score]="owned.score"
														[rating]="owned.card.rating"
														[image]="owned.card.fileName"
														[paused]="isBoosterOpening()"
														[showLoader]="true"
														[author]="owned.card.author"
													/>
												</div>
											</div>
									}
								</div>
								@if (favoritesPoolTotalPages() > 1) {
									<peps-page-selector
										[page]="favoritesPoolPage()"
										[totalPages]="favoritesPoolTotalPages()"
										(pageChange)="onFavoritesPoolPageChange($event)"
										[goToTop]="false"
									></peps-page-selector>
								}
							}
						</div>

					} @else {
						<div class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
							     stroke="currentColor" class="size-10 lg:size-11 text-peps-dark-200/20">
								<path stroke-linecap="round" stroke-linejoin="round"
								      d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"/>
							</svg>
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/30 tracking-wider">{{ 'page.profile.favorites.no-cards' | translate }}</span>
						</div>
					}
				</div>
			}

			<!-- ─── PRONOSTICS ─── -->
			@if (selectedTab() === 'predictions') {
				<div class="flex flex-col gap-8 animate-fade-in">

					<!-- Stats grid -->
					@if (userStats()?.betStats) {
						<div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
							<div class="border border-peps-dark-500 p-4 flex flex-col items-center gap-2 text-center"
							     style="background: linear-gradient(135deg, rgba(238,201,50,0.03) 0%, transparent 70%);">
								<span
									class="text-3xl lg:text-4xl font-dinpro text-peps-gold tabular-nums">{{ userStats()!.betStats.rank }}</span>
								<span
									class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-dark-200/45 tracking-wider leading-tight">{{ 'page.profile.rank' | translate }}</span>
							</div>
							<div class="border border-peps-dark-500 p-4 flex flex-col items-center gap-2 text-center"
							     style="background: linear-gradient(135deg, rgba(238,201,50,0.03) 0%, transparent 70%);">
								<span
									class="text-3xl lg:text-4xl font-dinpro text-peps-gold tabular-nums">{{ userStats()!.betStats.points }}</span>
								<span
									class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-dark-200/45 tracking-wider leading-tight">{{ 'page.profile.points' | translate }}</span>
							</div>
							<div class="border border-peps-dark-500 p-4 flex flex-col items-center gap-2 text-center"
							     style="background: linear-gradient(135deg, rgba(238,201,50,0.03) 0%, transparent 70%);">
								<span
									class="text-3xl lg:text-4xl font-dinpro text-peps-gold tabular-nums">{{ userStats()!.betStats.total }}</span>
								<span
									class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-dark-200/45 tracking-wider leading-tight">{{ 'page.profile.total-bet' | translate }}</span>
							</div>
							<div class="border border-peps-dark-500 p-4 flex flex-col items-center gap-2 text-center"
							     style="background: linear-gradient(135deg, rgba(238,201,50,0.03) 0%, transparent 70%);">
								<span
									class="text-3xl lg:text-4xl font-dinpro text-peps-gold tabular-nums">{{ userStats()!.betStats.won }}</span>
								<span
									class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-dark-200/45 tracking-wider leading-tight">{{ 'page.profile.total-won' | translate }}</span>
							</div>
							<div class="border border-peps-dark-500 p-4 flex flex-col items-center gap-2 text-center"
							     style="background: linear-gradient(135deg, rgba(238,201,50,0.03) 0%, transparent 70%);">
								<span
									class="text-3xl lg:text-4xl font-dinpro text-peps-gold tabular-nums">{{ userStats()!.betStats.lost }}</span>
								<span
									class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-dark-200/45 tracking-wider leading-tight">{{ 'page.profile.total-lost' | translate }}</span>
							</div>
							<div class="border border-peps-dark-500 p-4 flex flex-col items-center gap-2 text-center"
							     style="background: linear-gradient(135deg, rgba(238,201,50,0.03) 0%, transparent 70%);">
								<span
									class="text-3xl lg:text-4xl font-dinpro text-peps-gold tabular-nums">{{ userStats()!.betStats.perfects }}</span>
								<span
									class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-dark-200/45 tracking-wider leading-tight">{{ 'page.profile.perfect' | translate }}</span>
							</div>
						</div>
					} @else {
						<div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
							@for (i of [1, 2, 3, 4, 5, 6]; track i) {
								<div class="border border-peps-dark-500 p-4 h-20 bg-peps-dark-600/30"></div>
							}
						</div>
					}

					<div class="flex flex-col gap-4">
						<div class="flex items-center gap-4">
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.profile.tab-bet.bet-history-title' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>

						<div class="overflow-x-auto custom-scrollbar">
							<table
								class="min-w-[580px] w-full border-separate border-spacing-y-1.5 text-base lg:text-lg font-notosans uppercase">
								<thead>
								<tr class="text-peps-dark-200/40 text-xs lg:text-sm tracking-wider">
									<th class="px-4 py-2 text-left">{{ 'page.profile.date' | translate }}</th>
									<th class="px-4 py-2 text-left min-w-[130px]">{{ 'page.profile.match' | translate }}</th>
									<th class="px-4 py-2 text-left min-w-[120px]">{{ 'page.profile.your-prediction' | translate }}</th>
									<th class="px-4 py-2 text-left min-w-[120px]">{{ 'page.profile.result' | translate }}</th>
									<th class="px-4 py-2 text-right">{{ 'page.profile.points-earned' | translate }}</th>
								</tr>
								</thead>
								<tbody>
									@if (predictions().length) {
										@for (prediction of predictions(); track prediction.id) {
											<tr class="bg-peps-dark-600 border border-peps-dark-500/0 hover:bg-peps-dark-600/70 transition-colors duration-150">
												<td class="px-4 py-3 text-peps-dark-200/60 text-sm lg:text-base">
													{{ prediction.createdAt | localizedDate:'dd/MM/yyyy' }}
												</td>
												<td class="px-4 py-3">
													<div class="flex flex-row gap-3 items-center whitespace-nowrap">
														<img [src]="minioBaseUrl + prediction.matchup.team1.imageKey"
														     [alt]="prediction.matchup.team1.name"
														     class="h-7 flex-shrink-0">
														<span class="text-peps-dark-200/40 text-xs lg:text-sm">VS</span>
														<img [src]="minioBaseUrl + prediction.matchup.team2.imageKey"
														     [alt]="prediction.matchup.team2.name"
														     class="h-7 flex-shrink-0">
													</div>
												</td>
												<td class="px-4 py-3">
													<div class="flex flex-row gap-3 items-center whitespace-nowrap">
														<img [src]="minioBaseUrl + prediction.winner.imageKey"
														     [alt]="prediction.winner.name" class="h-7 flex-shrink-0">
														<span
															class="text-peps-dark-200/60 text-sm lg:text-base">{{ prediction.score }}</span>
													</div>
												</td>
												<td class="px-4 py-3">
													@if (prediction.matchup.winner) {
														<div class="flex flex-row gap-3 items-center whitespace-nowrap">
															<img
																[src]="minioBaseUrl + prediction.matchup.winner!.imageKey"
																[alt]="prediction.matchup.winner!.name"
																class="h-7 flex-shrink-0">
															<span class="text-peps-dark-200/60 text-sm lg:text-base">
																{{ prediction.matchup.team1Score }}
																- {{ prediction.matchup.team2Score }}
															</span>
														</div>
													} @else {
														<span
															class="text-peps-dark-200/30 text-sm lg:text-base">{{ 'page.profile.result-soon' | translate }}</span>
													}
												</td>
												<td class="px-4 py-3 text-right">
													@if (prediction.pointsEarned !== null) {
														<span class="inline-flex items-baseline gap-1">
															<span [ngClass]="{
																'text-green-400': prediction.pointsEarned! > 0 && prediction.pointsEarned! < 3,
																'text-peps-gold': prediction.pointsEarned! >= 3,
																'text-peps-dark-200/50': prediction.pointsEarned === 0
															}" class="font-dinpro text-base lg:text-lg">
																{{ prediction.pointsEarned! > 0 ? '+' + prediction.pointsEarned! : prediction.pointsEarned! }}
															</span>
															<span class="text-xs lg:text-sm text-peps-dark-200/40">pts</span>
														</span>
													} @else {
														<span
															class="text-xs lg:text-sm text-peps-dark-200/30">{{ 'page.profile.soon-earn' | translate }}</span>
													}
												</td>
											</tr>
										}
									} @else {
										<tr>
											<td colspan="5"
											    class="py-12 text-center text-peps-dark-200/30 text-sm lg:text-base uppercase font-dinpro-medium tracking-wider">
												{{ 'page.profile.no-prediction' | translate }}
											</td>
										</tr>
									}
								</tbody>
							</table>
						</div>

						<peps-page-selector
							[page]="page"
							[totalPages]="totalPages"
							(pageChange)="onPageChange($event)"
							[goToTop]="false"
						></peps-page-selector>
					</div>

				</div>
			}

			<!-- ─── ACHIEVEMENTS ─── -->
			@if (selectedTab() === 'achievements') {
				<div class="flex flex-col gap-8 animate-fade-in">

					<div class="flex flex-col gap-5">
						<div class="flex items-center gap-4">
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.profile.achievements.title' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>

						@if (userStats()?.badges?.length) {
							<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
								@for (badge of userStats()!.badges; track badge.id) {
									<div
										class="border border-peps-dark-500 p-4 flex flex-row items-center gap-3 text-center hover:border-peps-gold/30 transition-colors duration-200"
										style="background: linear-gradient(135deg, rgba(238,201,50,0.04) 0%, transparent 60%);">
										<div
											class="w-12 h-12 rounded-full border border-peps-gold/30 bg-peps-gold/5 flex items-center justify-center">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
											     stroke-width="1.5" stroke="currentColor"
											     class="size-6 lg:size-7 text-peps-gold/60">
												<path stroke-linecap="round" stroke-linejoin="round"
												      d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"/>
											</svg>
										</div>
										<div class="flex flex-col items-start gap-1">
											<span
												class="text-base lg:text-lg font-dinpro uppercase text-peps-dark-200 leading-tight">{{ badge.translations[translateDynamicService.getLang()].name }}</span>
											<span
												class="text-sm lg:text-base font-notosans text-peps-dark-200/35 text-left">{{ badge.translations[translateDynamicService.getLang()].description }}</span>
										</div>
									</div>
								}
							</div>
						} @else {
							<div
								class="border border-peps-dark-500 border-dashed py-16 flex flex-col items-center gap-3">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
								     stroke="currentColor"
								     class="size-10 lg:size-11 text-peps-dark-200/20">
									<path stroke-linecap="round" stroke-linejoin="round"
									      d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"/>
								</svg>
								<span
									class="text-sm lg:text-base uppercase font-dinpro text-peps-dark-200/30 tracking-wider">{{ 'page.profile.achievements.empty' | translate }}</span>
							</div>
						}
					</div>

				</div>
			}

			<!-- ─── COMPTE ─── -->
			@if (selectedTab() === 'account') {
				<div class="flex flex-col gap-8 max-w-xl animate-fade-in">

					<div class="flex flex-col gap-4">
						<div class="flex items-center gap-4">
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-gold/50 tracking-[0.3em]">{{ 'page.profile.account.info-title' | translate }}</span>
							<div class="flex-1 h-px bg-peps-dark-500"></div>
						</div>
						<div class="border border-peps-dark-500 divide-y divide-peps-dark-500">
							<div class="flex items-center justify-between px-5 py-4">
								<span
									class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/40 tracking-wider">{{ 'page.profile.account.username-label' | translate }}</span>
								<span
									class="text-lg lg:text-xl font-dinpro text-peps-dark-200">{{ user()?.username ?? '—' }}</span>
							</div>
							<div class="flex items-center justify-between px-5 py-4 gap-4">
								<span
									class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-dark-200/40 tracking-wider shrink-0">{{ 'page.profile.account.discord-label' | translate }}</span>
								@if (discordStatus()?.linked) {
									<div class="flex items-center gap-3 min-w-0">
										<span class="inline-flex items-center gap-2 min-w-0 text-sm lg:text-base font-dinpro text-peps-dark-200">
											@if (discordStatus()?.discordAvatarUrl) {
												<img [src]="$safeNavigationMigration(discordStatus()?.discordAvatarUrl)" alt=""
												     class="w-6 h-6 rounded-full shrink-0">
											}
											<span class="truncate">{{ discordStatus()?.discordUsername }}</span>
										</span>
										<button
											(click)="unlinkDiscord()"
											(keydown.enter)="unlinkDiscord()"
											[disabled]="isUnlinkingDiscord()"
											class="shrink-0 text-xs lg:text-sm uppercase font-dinpro-medium px-3 py-2 border border-peps-red/40 text-peps-red/70 hover:bg-peps-red/10 hover:border-peps-red/60 hover:text-peps-red transition-colors duration-200 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
										>{{ 'page.profile.account.discord-unlink-btn' | translate }}
										</button>
									</div>
								} @else {
									<button
										(click)="linkDiscord()"
										(keydown.enter)="linkDiscord()"
										[disabled]="isLinkingDiscord()"
										class="shrink-0 text-xs lg:text-sm uppercase font-dinpro-medium px-4 py-2.5 border border-peps-gold/40 text-peps-gold/70 hover:bg-peps-gold/10 hover:border-peps-gold/60 hover:text-peps-gold transition-colors duration-200 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
									>{{ 'page.profile.account.discord-link-btn' | translate }}
									</button>
								}
							</div>
						</div>
					</div>

					<div class="flex flex-col gap-4">
						<div class="flex items-center gap-4">
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium text-peps-red/50 tracking-[0.3em]">{{ 'page.profile.account.danger-zone' | translate }}</span>
							<div class="flex-1 h-px bg-peps-red/20"></div>
						</div>
						<div
							class="border border-peps-red/20 p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
							<div class="flex flex-col gap-1">
								<span
									class="text-base lg:text-lg font-dinpro uppercase text-peps-dark-200">{{ 'page.profile.delete-account.button' | translate }}</span>
								<span
									class="text-sm lg:text-base font-notosans text-peps-dark-200/35 leading-relaxed">{{ 'page.profile.account.danger-description' | translate }}</span>
							</div>

							@if (!isWantDeleteAccount()) {
								<button
									(click)="isWantDeleteAccount.set(true)"
									(keydown.enter)="isWantDeleteAccount.set(true)"
									class="shrink-0 text-sm lg:text-base uppercase font-dinpro-medium px-4 py-2.5 border border-peps-red/40 text-peps-red/70 hover:bg-peps-red/10 hover:border-peps-red/60 hover:text-peps-red transition-colors duration-200 cursor-pointer"
								>{{ 'page.profile.account.delete-btn' | translate }}
								</button>
							} @else {
								<div
									@fadeInOut
									class="fixed inset-0 z-50 flex items-center justify-center bg-peps-dark-900/50"
									(click)="onBackgroundClick($event)"
								>
									<div
										@scaleInOut
										class="h-fit w-full bg-peps-dark-700 relative p-8 custom-vertical-scrollbar xl:w-7/12 border border-peps-gold"
									>
										<span
											class="uppercase text-3xl lg:text-4xl border-b border-b-peps-gold">{{ 'page.profile.delete-account.title' | translate }}</span>
										<button
											class="absolute top-4 right-4 text-peps-dark-200 hover:text-white transition cursor-pointer"
											(click)="closeDeleteAccount()"
											(keydown.enter)="closeDeleteAccount()"
										>
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
											     stroke-width="1.5" stroke="currentColor" class="size-10 lg:size-11">
												<path stroke-linecap="round" stroke-linejoin="round"
												      d="M6 18 18 6M6 6l12 12"/>
											</svg>
										</button>

										<div class="flex flex-col gap-4 pt-6">

											<div
												class="flex flex-col gap-4 items-start font-notosans w-full relative md:w-2/3">
												<span>{{ 'page.profile.delete-account.text' | translate }}</span>
												<span>{{ 'page.profile.delete-account.text-second' | translate }}</span>
											</div>
											<img src="assets/images/fdgod_delete_account.png" alt=""
											     class="absolute hidden md:block h-96 right-10 bottom-0"/>

											<div class="flex flex-col sm:flex-row gap-2 w-full md:w-2/3 items-center">
												<button
													(click)="isWantDeleteAccount.set(false)"
													(keydown.enter)="isWantDeleteAccount.set(false)"
													class="w-full font-notsans uppercase p-4 bg-peps-gold text-peps-dark-900 cursor-pointer drop-shadow-[0_0_8px_rgba(238,201,50,0.7)] hover:brightness-110 hover:drop-shadow-[0_0_12px_rgba(238,201,50,0.9)] transition-all duration-200"
												>{{ 'page.profile.delete-account.cancel' | translate }}
												</button>

												<button
													(click)="deleteAccount()"
													(keydown.enter)="deleteAccount()"
													class="w-full font-notsans uppercase p-4 bg-peps-red-hover hover:bg-peps-red cursor-pointer sm:scale-90"
												>{{ 'page.profile.delete-account.confirm' | translate }}
												</button>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					</div>

				</div>
			}

		</div>

		<div class="w-full h-px bg-peps-dark-500"></div>

		<div class="grid grid-cols-1 lg:grid-cols-[3fr_2fr] lg:grid-rows-2 gap-px bg-peps-dark-500"
		     style="min-height: 64vh;">

			<!-- ─── 01 QUESTS ─────────────── -->
			<div
				class="lg:row-span-2 group relative flex flex-col bg-peps-dark-700 overflow-hidden cursor-pointer transition-colors duration-500 hover:bg-[#0e0e0f]"
				(click)="navigateTo('/battlepeps')"
				(keydown.enter)="navigateTo('/battlepeps')"
				tabindex="0"
			>
				<img src="/assets/images/battlepeps.png" alt=""
				     class="absolute bottom-0 right-0 w-1/2 pointer-events-none select-none translate-x-1/6 translate-y-1/6 opacity-[0.9]">
				<div class="absolute inset-0 pointer-events-none opacity-[0.012]"
				     style="background-image: repeating-linear-gradient(135deg, #EEC932 0, #EEC932 1px, transparent 0, transparent 56px);">
				</div>
				<div class="absolute left-0 top-0 bottom-0 bg-peps-gold"
				     style="width: 3px;">
				</div>
				<div
					class="absolute left-0 top-0 bottom-0 bg-peps-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300"
					style="width: 6px;">
				</div>
				<div
					class="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
					style="background: linear-gradient(135deg, rgba(238,201,50,0.05) 0%, transparent 55%);">
				</div>
				<div class="relative flex flex-col justify-between h-full p-8 lg:p-12 gap-8">
					<div class="flex items-center gap-3">
						<div class="flex-1 h-px bg-peps-dark-500"></div>
						<span
							class="text-xs lg:text-sm uppercase font-dinpro-medium tracking-[0.2em] text-peps-gold/50 border border-peps-gold/15 px-3 py-1">
							{{ 'page.hub.quests.tag' | translate }}
						</span>
					</div>
					<div class="flex flex-col gap-5 flex-1 justify-center">
						<h2 class="text-5xl lg:text-8xl xl:text-9xl uppercase font-dinpro text-peps-dark-200 leading-none transition-colors duration-300 group-hover:text-white">
							{{ 'page.hub.quests.title' | translate }}
						</h2>
						<p class="font-notosans text-base lg:text-lg text-peps-dark-200/45 leading-relaxed max-w-sm">
							{{ 'page.hub.quests.description' | translate }}
						</p>
					</div>
					<div class="flex items-center gap-3 text-peps-gold">
						<div
							class="h-px bg-peps-gold/30 transition-all duration-300 ease-out w-6 group-hover:w-14"></div>
						<span
							class="text-base lg:text-lg uppercase font-dinpro-medium tracking-widest">{{ 'page.hub.quests.cta' | translate }}</span>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
						     class="size-4 lg:size-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1.5">
							<path fill-rule="evenodd"
							      d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
							      clip-rule="evenodd"/>
						</svg>
					</div>
				</div>
			</div>

			<!-- ─── 02 PRONOS ────────────────────────────── -->
			<div
				class="group relative flex flex-col bg-peps-dark-700 overflow-hidden cursor-pointer transition-colors duration-500 hover:bg-[#0e0e0f]"
				(click)="navigateTo('/bet/matches')"
				(keydown.enter)="navigateTo('/bet/matches')"
				tabindex="0"
			>
				<img src="/assets/images/pronos.png" alt=""
				     class="absolute bottom-0 right-0 w-1/2 pointer-events-none select-none translate-x-1/16 translate-y-1/6 opacity-[0.9]">
				<div class="absolute left-0 top-0 bottom-0" style="width: 3px; background: #C96527;"></div>
				<div
					class="absolute left-0 top-0 bottom-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
					style="width: 6px; background: #C96527;">
				</div>
				<div
					class="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
					style="background: linear-gradient(135deg, rgba(201,101,39,0.06) 0%, transparent 55%);">
				</div>
				<div class="relative flex flex-col justify-between h-full p-8 gap-6">
					<div class="flex items-center gap-3">
						<div class="flex-1 h-px bg-peps-dark-500"></div>
						<span class="text-xs lg:text-sm uppercase font-dinpro-medium tracking-[0.2em] px-3 py-1"
						      style="color:rgba(201,101,39,0.65); border: 1px solid rgba(201,101,39,0.2);">
							{{ 'page.hub.bet.tag' | translate }}
						</span>
					</div>
					<div class="flex flex-col gap-3 flex-1 justify-center">
						<h2 class="text-4xl lg:text-6xl uppercase font-dinpro text-peps-dark-200 leading-none transition-colors duration-300 group-hover:text-white">
							{{ 'page.hub.bet.title' | translate }}
						</h2>
						<p class="font-notosans text-sm lg:text-base text-peps-dark-200/40 leading-relaxed max-w-xs">
							{{ 'page.hub.bet.description' | translate }}
						</p>
					</div>
					<div class="flex flex-col gap-3">
						<div>
							<button
								class="text-xs lg:text-sm uppercase font-dinpro-medium px-3 py-1 border border-peps-dark-500 text-peps-dark-200/30 hover:text-peps-dark-200/60 hover:border-peps-dark-400 transition-colors duration-200 cursor-pointer"
								(click)="$event.stopPropagation(); navigateTo('/bet/leaderboard')"
								(keydown.enter)="navigateTo('/bet/leaderboard')"
							>{{ 'page.hub.bet.leaderboard' | translate }}
							</button>
						</div>
						<div class="flex items-center gap-2" style="color:#C96527;">
							<div class="h-px transition-all duration-300 w-4 group-hover:w-10"
							     style="background:#C96527; opacity:0.4;"></div>
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium tracking-widest">{{ 'page.hub.bet.cta' | translate }}</span>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
							     class="size-3.5 lg:size-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1.5">
								<path fill-rule="evenodd"
								      d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
								      clip-rule="evenodd"/>
							</svg>
						</div>
					</div>
				</div>
			</div>

			<!-- ─── 03 COLLECTION ─────────────────────── -->
			<div
				class="group relative flex flex-col bg-peps-dark-700 overflow-hidden cursor-pointer transition-colors duration-500 hover:bg-[#0e0e0f]"
				(click)="navigateTo('/collection/shop')"
				(keydown.enter)="navigateTo('/collection/shop')"
				tabindex="0"
			>
				<img src="/assets/images/collection.png" alt=""
				     class="absolute bottom-0 right-0 w-1/2 pointer-events-none select-none translate-x-1/6 translate-y-1/6 opacity-[0.9]">
				<div class="absolute left-0 top-0 bottom-0" style="width: 3px; background: #9146FF;"></div>
				<div
					class="absolute left-0 top-0 bottom-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
					style="width: 6px; background: #9146FF;">
				</div>
				<div
					class="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
					style="background: linear-gradient(135deg, rgba(145,70,255,0.06) 0%, transparent 55%);">
				</div>
				<div class="relative flex flex-col justify-between h-full p-8 gap-6">
					<div class="flex items-center gap-3">
						<div class="flex-1 h-px bg-peps-dark-500"></div>
						<span class="text-xs lg:text-sm uppercase font-dinpro-medium tracking-[0.2em] px-3 py-1"
						      style="color:rgba(145,70,255,0.75); border: 1px solid rgba(145,70,255,0.25);">
							{{ 'page.hub.collection.tag' | translate }}
						</span>
					</div>
					<div class="flex flex-col gap-3 flex-1 justify-center">
						<h2 class="text-4xl lg:text-6xl uppercase font-dinpro text-peps-dark-200 leading-none transition-colors duration-300 group-hover:text-white">
							{{ 'page.hub.collection.title' | translate }}
						</h2>
						<p class="font-notosans text-sm lg:text-base text-peps-dark-200/40 leading-relaxed max-w-xs">
							{{ 'page.hub.collection.description' | translate }}
						</p>
					</div>
					<div class="flex flex-col gap-3">
						<div class="flex gap-2">
							<button
								class="text-xs lg:text-sm uppercase font-dinpro-medium px-3 py-1 border border-peps-dark-500 text-peps-dark-200/30 hover:text-peps-dark-200/60 hover:border-peps-dark-400 transition-colors duration-200 cursor-pointer"
								(click)="$event.stopPropagation(); navigateTo('/collection/marketplace')"
								(keydown.enter)="navigateTo('/collection/marketplace')"
							>{{ 'page.hub.collection.market' | translate }}
							</button>
							<button
								class="text-xs lg:text-sm uppercase font-dinpro-medium px-3 py-1 border border-peps-dark-500 text-peps-dark-200/30 hover:text-peps-dark-200/60 hover:border-peps-dark-400 transition-colors duration-200 cursor-pointer"
								(click)="$event.stopPropagation(); navigateTo('/collection/shop')"
								(keydown.enter)="navigateTo('/collection/shop')"
							>{{ 'page.hub.collection.shop' | translate }}
							</button>
						</div>
						<div class="flex items-center gap-2" style="color:#9146FF;">
							<div class="h-px transition-all duration-300 w-4 group-hover:w-10"
							     style="background:#9146FF; opacity:0.4;"></div>
							<span
								class="text-sm lg:text-base uppercase font-dinpro-medium tracking-widest">{{ 'page.hub.collection.cta' | translate }}</span>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
							     class="size-3.5 lg:size-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1.5">
								<path fill-rule="evenodd"
								      d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z"
								      clip-rule="evenodd"/>
							</svg>
						</div>
					</div>
				</div>
			</div>

		</div>

	</div>
}
